export const EMPTY_VALUE = '<p><br></p>'
